import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity, Modal, ScrollView } from 'react-native'
import Colours from '../../utils/Colours'
import MenuBar from '../../icons/MenuBar'
import MoneyIcon from '../../icons/MoneyIcon'
import TableTransactionHistoryScreen from './TableTransactionHistoryScreen'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'


const TopHeaderTables = () => {
  const [showTableTransactions, setShowTableTransactions] = useState(false)

  const handleViewTableTransactions = () => {
    setShowTableTransactions(true)
  }

  return (

    <View style={styles.topHeaderContainer}>
      {/* <MenuBar color={Colours.DARKGRAY} /> */}
      {/* <BackArrow color={Colours.DARKGRAY} /> */}
      <Text style={{ fontSize: 20, color: Colours.DARKGRAY, fontFamily: 'Sen-Bold' }}>Tables</Text>
      <TouchableOpacity
        onPress={handleViewTableTransactions}
      >
        {/* <MoneyIcon color={Colours.DARKGRAY} height={30} width={30} /> */}
      </TouchableOpacity>



      <Modal
        visible={showTableTransactions}
        animationType='slide'
      >
        <TopHeaderComponent headerText={'Table Transaction History'} hideScreen={() => setShowTableTransactions(false)} />
        <ScrollView
          style={styles.componentStyle}
          contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}>

          <TableTransactionHistoryScreen

          />
        </ScrollView>
      </Modal>
    </View>

  )
}

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: '100%',

  },
  topHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    //   backgroundColor: "#12ff34",
    alignItems: "center",
    padding: 15,
    paddingTop: 20,
  },
})

export default TopHeaderTables